<template>
  <div>
    <HomeButton></HomeButton>
    <section class="bg-account-pages height-100vh">
      <div class="display-table">
        <div class="display-table-cell">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-5">
                <div class="card account-card">
                  <div class="card-body">
                    <div class="text-center mt-3">
                      <h3 class="font-weight-bold">
                        <a
                          href="/"
                          class="text-dark text-uppercase account-pages-logo"
                          >Startandu</a
                        >
                      </h3>
                      <p class="text-muted">
                        Registre-se para podermos crescer juntos!
                      </p>
                    </div>
                    <div class="p-3">
                      <form>
                        <div class="form-group">
                          <label for="username">Nome de usúario</label>
                          <input
                            type="text"
                            class="form-control"
                            id="username"
                            placeholder="usuário"
                          />
                        </div>

                        <div class="form-group">
                          <label for="userpassword">Senha</label>
                          <input
                            type="password"
                            class="form-control"
                            id="userpassword"
                            placeholder="senha"
                          />
                        </div>

                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customControlInline"
                          />
                          <label
                            class="custom-control-label"
                            for="customControlInline"
                            >Sou esquecido(a)!</label
                          >
                        </div>

                        <div class="mt-3">
                          <button
                            type="submit"
                            class="btn btn-custom btn-block"
                          >
                            Logar
                          </button>
                        </div>

                        <div class="mt-4 mb-0 text-center">
                          <a href="/forgot-password" class="text-dark"
                            ><i class="mdi mdi-lock"></i> Esqueceu sua senha?</a
                          >
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <!-- end card -->
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </section>
    <!-- end account-pages  -->
  </div>
</template>

<script>
"use strict";
import HomeButton from "./Elements/HomeButton";

export default {
  name: "Login",
  components: {
    HomeButton
  }
};
</script>
